import React from "react";

export default function AppLoader({ error, onRetry }) {
  return (
    <div className="app-loader">
      {error ? (
        <>
          <div className="empty-icon">⚠️</div>
          <p>{error}</p>
          {onRetry && (
            <button type="button" className="btn btn-primary" onClick={onRetry}>
              Try Again
            </button>
          )}
        </>
      ) : (
        <>
          <div className="spinner" />
          <span>Loading Job Register Portal...</span>
        </>
      )}
    </div>
  );
}
